<template>
  <v-card>
    <v-tabs height="64" v-model="activeTab" class="sticky top-0">
      <v-tab v-for="(tab, $i) in tabs" :key="$i" :href="`#${tab.tab}`">
        {{ tab.title }}
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="(tab, $i) in tabs" :key="$i" :value="tab.tab">
        <div class="overflow-y-auto" :style="{ height: tableHeight }">
          <component :inquiry="inquiry" :is="tab.component" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import InquiriesEvents from './InquiriesEvents'
import InquiriesMatches from './InquiriesMatches'
import { tableHeight } from '@/mixins/tableHeight'

export default {
  name: 'InquiriesTabs',

  mixins: [tableHeight(161)],

  props: {
    inquiry: Object,
  },

  data() {
    return {
      activeTab: 'matches',
    }
  },

  computed: {
    tabs() {
      return [
        {
          tab: 'matches',
          title: 'Matchningar',
          component: InquiriesMatches,
        },
        {
          tab: 'events',
          title: 'Aktivitetslogg',
          component: InquiriesEvents,
        },
      ]
    },
  },
}
</script>
